import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

import { mq } from "../../utils";

interface Props extends PropsWithChildren {
  testID: string;
}

export function NavigationBar(props: Props) {
  return (
    <div className={styles.container} data-testid={props.testID}>
      {props.children}
    </div>
  );
}

const styles = {
  container: css(
    {
      display: "flex",
      alignItems: "center",
      gap: "var(--space-2-5)",
      "> div:last-child": { flexGrow: 1 },
    },
    mq({
      minHeight: ["64px", "64px", "72px"],
      paddingLeft: ["var(--space-4)", "var(--space-4)", "var(--space-8)"],
      paddingRight: ["var(--space-4)", "var(--space-4)", "var(--space-8)"],
    })
  ),
};
